import * as Api from '@ViewModels';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';

interface GetTagCategoriesParams {
	enabled?: boolean;
	impersonationContext?: Api.IImpersonationContext;
	pageSize?: number;
	sort?: Api.ISortDescriptor;
	expandTags?: boolean;
	query?: string;
}

export function useGetTagCategoriesQuery({
	enabled = true,
	impersonationContext,
	sort,
	expandTags = false,
	query,
}: GetTagCategoriesParams) {
	const userSession = useUserSession();

	return useInfiniteQuery({
		enabled,
		queryKey: ['tagcategory', impersonationContext, sort.sort, sort.sortBy, query],
		queryFn: async ({ pageParam }) => {
			return userSession.webServiceHelper.callAsync<Api.IPagedCollection<Api.ITagCategory>>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: 'tagcategory',
					queryParams: {
						pageToken: pageParam,
						expand: expandTags ? 'Tags' : null,
						sort: sort.sort,
						sortBy: sort.sortBy,
						query,
					},
				}),
				'GET'
			);
		},
		getNextPageParam: lastPage => lastPage.pageToken,
		initialPageParam: '',
	});
}

export function invalidateGetTagCategoriesQuery() {
	return reactQueryClient.invalidateQueries({ queryKey: ['tagcategory'] });
}
